import React from 'react';
import If from '../../../components/Shared/If/If';
import Case from '../../../components/Shared/Switch/Case';
import Switch from '../../../components/Shared/Switch/Switch';
import { MANUAL } from '../../../settings/settings';
import { openExternalLinkInPane } from '../../../utils/link-helper';
import {
  Initiated,
  ReadyValidation,
  ReInitiated,
  Verified,
  Failed,
} from './StatusMessages';
import config from '../../../config/config';

export const BankStatusFailure = ({
  eVerification: { checkStatus, verifiedBank },
  handleClose,
  path,
}) => {
  const navigateToLinkedBankAccounts = () => {
    openExternalLinkInPane(
      `${config.url}/usis/my-accounts/profile/linked-bank-accounts`
    );
  };
  return (
    <div>
      <Switch test={path}>
        <Case value={MANUAL}>
          <If test={checkStatus === 20}>
            <Initiated
              handleClose={handleClose}
              navigateToLinkedBankAccounts={navigateToLinkedBankAccounts}
            />
          </If>
          <If test={checkStatus === 30}>
            <ReadyValidation
              handleClose={handleClose}
              navigateToLinkedBankAccounts={navigateToLinkedBankAccounts}
            />
          </If>
          <If test={checkStatus === 80}>
            <ReInitiated
              handleClose={handleClose}
              navigateToLinkedBankAccounts={navigateToLinkedBankAccounts}
            />
          </If>
          <If test={verifiedBank}>
            <Verified
              handleClose={handleClose}
              navigateToLinkedBankAccounts={navigateToLinkedBankAccounts}
              path={path}
            />
          </If>
          <If test={checkStatus === 50 || checkStatus === 60}>
            <Failed handleClose={handleClose} />
          </If>
        </Case>
      </Switch>
    </div>
  );
};
